export default __webpack_public_path__ + "static/FilsonSoft-Light-d49d3ddff8d0713780125ef04babb156.ttf";